module.exports = __webpack_public_path__ + "img/Comic06-2.65b188ac.png";